<template>
    <div>
        <vs-popup title="환자 리스트 업로드" :active.sync="popupOpen" fullscreen>
            <div v-show="uploadShow">
                <div class="p5 mb-6">
                    <a href="/file/sample_ver_20220207_2.xlsx"><vs-button color="primary" type="border">환자 업로드 샘플 다운로드</vs-button></a>
                </div>
                <div class="p5 mb-1" style="color:red">* 업로드 샘플을 다운로드 하여 형식을 맞춰주시기 바랍니다.</div>
                <div class="p5 mb-1" style="color:red">* [환자고유키]의 경우 신규 환자는 공백, 기존 환자의 수정은 고유키를 정확하게 입력해주세요.</div>
                <div class="p5 mb-1" style="color:red">* [환자고유키]가 중복 될 경우의 수정은 중복 중 가장 마지막 행의 데이터로 수정 됩니다.</div>
                <input class="w-full mb-3" type="file" name="excelUpload" id="excelUpload" />
                <vs-button class="mr-3" color="warning" type="filled" @click="closePopup">취소</vs-button>
                <vs-button color="primary" type="filled" @click="fileUpload">저장</vs-button>
            </div>
            <br />
            <div v-if="err_data.length > 0">
                <vs-table class="w-full" :data="err_data">
                    <template slot="header" class="mb-3">
                        <h3 class="mt-3 mb-3">저장실패 리스트</h3>
                        <div class="mt-3 ">
                            <vs-button color="success" type="filled" @click="failListSave">리스트 수정&저장</vs-button>
                        </div>
                    </template>
                    <template slot="thead">
                        <vs-th class="w-auto text-center"><div class="vs-table-text">환자고유키</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">차트번호</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">이름</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">진단명</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">기수</div></vs-th>
                        <vs-th class="w-auto text-center">
                            <div class="vs-table-text">주민번호<br />ex(123456-1234567)</div>
                        </vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">생년월일</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">성별</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">나이</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">치료플랜</div></vs-th>

                        <!--  -->
                        <vs-th class="w-auto text-center"><div class="vs-table-text">EXPIRE</div></vs-th>
                        <!--  -->

                        <vs-th class="w-auto text-center"><div class="vs-table-text">신입재입</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">현재상태</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">병실</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">베드</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">최초입원일</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">입원예정일</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">입원예정시간</div></vs-th>

                        <!--  -->
                        <vs-th class="w-auto text-center"><div class="vs-table-text">퇴원예정시간</div></vs-th>
                        <!--  -->

                        <vs-th class="w-auto text-center"><div class="vs-table-text">퇴원예정일</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">완퇴여부</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">식사구분</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">식이</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">식이비고</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">주치의</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">협진의</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">연락처</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">주소지</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">보호자관계</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">보호자연락처</div></vs-th>

                        <!--  -->
                        <vs-th class="w-auto text-center"><div class="vs-table-text">보호자2관계</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">보호자2연락처</div></vs-th>
                        <!--  -->

                        <vs-th class="w-auto text-center"><div class="vs-table-text">본병원</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">기타사항</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">코로나검사여부</div></vs-th>

                        <!--  -->
                        <vs-th class="w-auto text-center"><div class="vs-table-text">부위</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">진단일</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">수술일</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">전이여부</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">전이부위</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">항암치료</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">방사선치료</div></vs-th>
                        <!-- <vs-th class="w-auto text-center"><div class="vs-table-text">항암제</div></vs-th> -->
                        <vs-th class="w-auto text-center"><div class="vs-table-text">항암제</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">복용약</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">기왕력</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">기왕력상세</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">기왕력기타</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">아침</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">점심</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">저녁</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">영양메모</div></vs-th>
                        <vs-th class="w-auto text-center"><div class="vs-table-text">알림톡수신자</div></vs-th>
                        <!--  -->

                        <vs-th class="w-auto text-center"><div class="vs-table-text">에러내용</div></vs-th>
                    </template>
                    <template slot-scope="{ data }">
                        <tbody>
                            <vs-tr :data="item" :key="index" v-for="(item, index) in data">
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="환자고유키" v-model="item.uid" />
                                </vs-td>
                                <vs-td>
                                    <vs-input type="number" class="inputx mb-3 w-full" placeholder="차트번호" v-model="item.chartNo" />
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="이름" v-model="item.username" />
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="진단명" v-model="item.sickness" />
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="기수" v-model="item.gisu" />
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="주민번호" v-model="item.jumin" @blur="juminCheck(index)" />
                                </vs-td>
                                <vs-td>
                                    <date-picker name="patientBirthday" v-model="item.patientBirthday" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker>
                                </vs-td>
                                <vs-td>
                                    <div>
                                        <vs-select autocomplete class="inputx mb-3 w-full" name="patientGender" v-model="item.patientGender" placeholder="성별 선택">
                                            <vs-select-item :value="'M'" :text="'남자'" />
                                            <vs-select-item :value="'F'" :text="'여자'" />
                                        </vs-select>
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <vs-input type="number" class="inputx mb-3 w-full" placeholder="나이" v-model="item.age" />
                                </vs-td>

                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="플랜" v-model="item.plan" />
                                </vs-td>
                                <vs-td>
                                    <vs-checkbox v-model="item.expire">
                                        Expire
                                    </vs-checkbox>
                                </vs-td>

                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="신입재입" v-model="item.newRe" />
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="cdStatus" v-model="item.cdStatus" placeholder="현재상태">
                                        <vs-select-item :value="item2.CD_STATUS" :text="item2.STATUS_NAME" v-for="(item2, index2) in statusList" :key="index2" />
                                    </vs-select>
                                </vs-td>

                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="병실" v-model="item.medicalRoomNumberNm" />
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="베드" v-model="item.medicalRoomNumberCnt" />
                                </vs-td>
                                <vs-td>
                                    <date-picker name="inInitDate" v-model="item.inInitDate" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker>
                                </vs-td>
                                <vs-td>
                                    <date-picker name="inInitDate" v-model="item.inDate" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="입원예정시간" v-model="item.inTime" />
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="퇴원예정시간" v-model="item.outTime" />
                                </vs-td>
                                <vs-td>
                                    <date-picker name="outDate" v-model="item.outDate" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker>
                                </vs-td>
                                <vs-td>
                                    <div>
                                        <vs-select autocomplete class="inputx mb-3 w-full" name="completeYn" v-model="item.completeYn" placeholder="완퇴여부 선택">
                                            <vs-select-item :value="'Y'" :text="'완퇴'" />
                                            <vs-select-item :value="'N'" :text="'비완퇴'" />
                                        </vs-select>
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="mealTime" v-model="item.mealTime" placeholder="식사구분 입력">
                                        <vs-select-item :value="item2.MEALTIME_NM" :text="item2.MEALTIME_NM" v-for="(item2, index2) in mealTimeList" :key="index2" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="mealName" v-model="item.mealName" placeholder="식이 입력">
                                        <vs-select-item :value="item2.MEALNAME" :text="item2.MEALNAME" v-for="(item2, index2) in mealNameList" :key="index2" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="식이비고" v-model="item.mealMemo" />
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="medical_member_name" v-model="item.medical_member_name" placeholder="주치의 선택">
                                        <vs-select-item :value="item2.MEDICAL_NM" :text="item2.MEDICAL_NM" v-for="(item2, index2) in medicalMemberList" :key="index2" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="westMedicalNm" v-model="item.westMedicalNm" placeholder="협진의 선택">
                                        <vs-select-item :value="item2.MEDICAL_NM" :text="item2.MEDICAL_NM" v-for="(item2, index2) in medicalMemberList" :key="index2" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="연락처" v-model="item.phone_number" />
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="address" v-model="item.address" placeholder="주소 입력">
                                        <div :key="index2" v-for="(item2, index2) in addrOptions">
                                            <vs-select-group :title="item2.title" v-if="item2.group">
                                                <vs-select-item :key="index2" :value="item2.value" :text="item2.text" v-for="(item2, index2) in item2.group" />
                                            </vs-select-group>
                                        </div>
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="protector" v-model="item.protector" placeholder="보호자관계 선택">
                                        <vs-select-item :value="item2.PROTECTOR_CODE" :text="item2.PROTECTOR" v-for="(item2, index2) in protectorList" :key="index2" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="보호자연락처" v-model="item.protectorPhone" />
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="protector2" v-model="item.protector2" placeholder="보호자2관계 선택">
                                        <vs-select-item :value="item2.PROTECTOR_CODE" :text="item2.PROTECTOR" v-for="(item2, index2) in protectorList" :key="index2" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="보호자2연락처" v-model="item.protectorPhone2" />
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="본병원" v-model="item.medical_name" />
                                </vs-td>
                                <vs-td>
                                    <vs-input class="inputx mb-3 w-full" placeholder="기타사항" v-model="item.memo" />
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="corona" v-model="item.corona" placeholder="코로나검사여부 선택">
                                        <vs-select-item :value="item2.CORONA" :text="item2.CORONA" v-for="(item2, index2) in coronaList" :key="index2" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="bodyPart" v-model="item.bodyPart" placeholder="ex) Lt">
                                        <vs-select-item value="" text="초기값" />
                                        <vs-select-item :value="item2.BODYPART" :text="item2.BODYPART" v-for="(item2, index2) in bodyPartList" :key="index2" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input name="diagnosisDate" v-model="item.diagnosisDate" class="vs-inputx normal w-full" />
                                </vs-td>
                                <vs-td>
                                    <vs-input name="operationDate" v-model="item.operationDate" :locale="'ko'" valueType="format" class="vs-inputx normal w-full" />
                                </vs-td>

                                <vs-td>
                                    <vs-input class="w-full" name="metastasisYn" v-model="item.metastasisYn" placeholder="ex) 유/무" />
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" name="metastasisPart" v-model="item.metastasisPart" placeholder="ex) 전이부위 작성" />
                                </vs-td>
                                <vs-td>
                                    <vs-input name="anticancerDate" v-model="item.anticancerDate" class="vs-inputx normal w-full" />
                                </vs-td>
                                <vs-td>
                                    <vs-input name="radiotherapyDate" v-model="item.radiotherapyDate" class="vs-inputx normal w-full" />
                                </vs-td>

                                <vs-td v-show="1 == 2">
                                    <vs-select autocomplete class="w-auto" name="antiagentYn" v-model="item.antiagentYn" placeholder="ex) 유/무">
                                        <vs-select-item :value="'Y'" :text="'유'" />
                                        <vs-select-item :value="'N'" :text="'무'" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input :disabled="item.antiagentYn != 'Y'" class="w-full" name="antiagent" v-model="item.antiagent" placeholder="ex) 항암제 작성" />
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" name="medication" v-model="item.medication" placeholder="ex) 복용약 작성" />
                                </vs-td>

                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="anamnesisYn" v-model="item.anamnesisYn" placeholder="ex) 유/무">
                                        <vs-select-item :value="'Y'" :text="'유'" />
                                        <vs-select-item :value="'N'" :text="'무'" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <ul class="centerx">
                                        <li v-for="(item2, index2) in anamnesisList" :key="index2">
                                            <vs-checkbox :disabled="item.anamnesisYn != 'Y'" v-model="item.anamnesis" :vs-value="item2.ANAMNESIS" @input="anamnesisInput(item)">{{
                                                item2.ANAMNESIS
                                            }}</vs-checkbox>
                                        </li>
                                    </ul>
                                </vs-td>
                                <vs-td>
                                    <vs-input :disabled="item.anamnesis.indexOf('기타') < 0" class="w-full" name="anamnesisEtc" v-model="item.anamnesisEtc" placeholder="ex) 기타 작성" />
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="breakfast_mealName" v-model="item.breakfast_mealName" placeholder="ex) 일반식 현미밥">
                                        <vs-select-item value="" text="초기값" />
                                        <vs-select-item :value="item2.MEALNAME" :text="item2.MEALNAME" v-for="(item2, index2) in mealNameList" :key="index2" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="lunch_mealName" v-model="item.lunch_mealName" placeholder="ex) 일반식 현미밥">
                                        <vs-select-item value="" text="초기값" />
                                        <vs-select-item :value="item2.MEALNAME" :text="item2.MEALNAME" v-for="(item2, index2) in mealNameList" :key="index2" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="dinner_mealName" v-model="item.dinner_mealName" placeholder="ex) 일반식 현미밥">
                                        <vs-select-item value="" text="초기값" />
                                        <vs-select-item :value="item2.MEALNAME" :text="item2.MEALNAME" v-for="(item2, index2) in mealNameList" :key="index2" />
                                    </vs-select>
                                </vs-td>

                                <vs-td>
                                    <vs-input class="w-full" name="nutritionMemo" v-model="item.nutritionMemo" placeholder="영양메모란" />
                                </vs-td>
                                <vs-td>
                                    <vs-select autocomplete class="w-auto" name="kakao_sender" v-model="item.kakao_sender">
                                        <vs-select-item value="1" text="환자본인" />
                                        <vs-select-item value="2" text="보호자" />
                                        <vs-select-item value="3" text="보호자2" />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-alert color="danger" title="err" active="true">{{ item.err_msg }}</vs-alert>
                                </vs-td>
                            </vs-tr>
                        </tbody>
                    </template>
                </vs-table>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import DatePicker from 'vue2-datepicker';
import dateClass from '@/../util/dateClass';
export default {
    components: {
        DatePicker,
    },
    props: {
        medicalMemberList: {
            type: Array,
        },
        medicalRoomNumberList: {
            type: Array,
        },
        statusList: {
            type: Array,
        },

        mealTimeList: {
            type: Array,
        },
        mealNameList: {
            type: Array,
        },
        addrOptions: {
            type: Array,
        },
        protectorList: {
            type: Array,
        },
        coronaList: {
            type: Array,
        },
        anamnesisList: {
            type: Array,
        },
        bodyPartList: {
            type: Array,
        },
    },
    data() {
        return {
            popupOpen: false,
            excelUpload: '',
            err_data: [],
            success_cnt: 0,
            false_cnt: 0,
            uploadShow: true,
            juminTF: false,
        };
    },
    methods: {
        juminCheck(index) {
            const _this = this.err_data[index];
            let err_msg = '';
            const jumin_1 = _this.jumin.split('-')[0];
            const jumin_2 = _this.jumin.split('-')[1];

            const patientGenderCode = jumin_2 != undefined && jumin_2.length > 0 ? jumin_2.substr(0, 1) : '';
            const genderCode_2000_Array = ['3', '4', '7', '8'];
            const genderCode_1900_Array = ['1', '2', '5', '6'];
            const genderCode_1800_Array = ['9', '0'];
            const today = dateClass.getDate('YYYYMMDD');
            const today_Y = dateClass.getDate('YYYY');
            const jumin_1_2000 = '20' + jumin_1;
            if (
                _this.jumin.indexOf('-') < 0 ||
                _this.jumin.length != 14 ||
                (_this.jumin.match(/-/g) != null && _this.jumin.match(/-/g).length != 1) ||
                isNaN(jumin_1) ||
                jumin_1.length != 6 ||
                jumin_2.length != 7 ||
                patientGenderCode == ''
            ) {
                err_msg = '주민번호를 [123456-1234567]형태로 올바르게 입력하여 주십시오.';
            } else {
                if (genderCode_2000_Array.indexOf(patientGenderCode) > -1 && today < jumin_1_2000) {
                    err_msg = '2000년대의 생년월일을 확인하여 주십시오.';
                }
            }
            if (err_msg != '') {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.juminTF = false;
                return;
            } else {
                _this.patientGender = patientGenderCode % 2 == 0 ? 'F' : 'M';
                let patientBirth_MD = jumin_1.substr(2, 2) + '-' + jumin_1.substr(4, 2);
                let patientBirth_Y = jumin_1.substr(0, 2);
                if (genderCode_2000_Array.indexOf(patientGenderCode) > -1) {
                    patientBirth_Y = '20' + patientBirth_Y;
                } else if (genderCode_1900_Array.indexOf(patientGenderCode) > -1) {
                    patientBirth_Y = '19' + patientBirth_Y;
                } else if (genderCode_1800_Array.indexOf(patientGenderCode) > -1) {
                    patientBirth_Y = '18' + patientBirth_Y;
                }
                _this.patientBirthday = patientBirth_Y + '-' + patientBirth_MD;
                _this.age = today_Y - patientBirth_Y + 1;
                this.juminTF = true;
            }
        },

        popupEvent() {
            this.popupOpen = true;
        },
        closePopup() {
            this.popupOpen = false;
            this.err_data = [];
            this.success_cnt = 0;
            this.false_cnt = 0;
            this.$parent.init('');
            document.getElementById('excelUpload').value = '';
            this.uploadShow = true;
        },
        async fileUpload() {
            const excelFile = document.getElementById('excelUpload').files[0] || '';

            if (excelFile == '') {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: '업로드 할 엑셀파일을 선택해주세요.',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }
            const ext = excelFile.name
                .split('.')
                .pop()
                .toLowerCase();
            const excel_ext_array = ['xlsx', 'xls'];
            if (excel_ext_array.indexOf(ext) == -1) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: ' xlsx,  xls 확장자만 업로드가 가능합니다.',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }
            let formData = new FormData();
            formData.append('excelFile', excelFile);

            const { data } = await axiosClass.file_post('/api/patient/listUploader', formData);

            if (data.thead_flag == false) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: data.err_meg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }

            this.err_data = data.err_data;
            this.success_cnt = data.success_cnt;
            this.false_cnt = data.false_cnt;
            this.uploadResultCheck();
        },
        async failListSave() {
            for (let i = 0; i < this.err_data.length; i++) {
                let expireYN = 'N';
                const expire = this.err_data[i].expire;
                if (expire) expireYN = 'Y';
                this.err_data[i].expireYN = expireYN;

                if (Array.isArray(this.err_data[i].anamnesis) && this.err_data[i].anamnesis.length > 0) {
                    this.err_data[i].anamnesisText = this.err_data[i].anamnesis.join();
                } else if (this.err_data[i].anamnesis.length > 0) {
                    this.err_data[i].anamnesisText = this.err_data[i].anamnesis;
                } else {
                    this.err_data[i].anamnesisText = '';
                }
            }

            const sendData = {
                err_data: this.err_data,
            };
            const { data } = await axiosClass.post('/api/patient/listUploaderModify', sendData, true);
            this.err_data = data.err_data;
            this.success_cnt = data.success_cnt;
            this.false_cnt = data.false_cnt;
            this.uploadResultCheck();
        },
        uploadResultCheck() {
            if (this.success_cnt > 0) {
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    text: '정상등록 (' + this.success_cnt + '건)',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            }
            if (this.false_cnt > 0) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: '실패 (' + this.false_cnt + '건)',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                document.getElementById('excelUpload').value = '';
                this.uploadShow = false;
            } else {
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    text: '업로드한 모든 파일이 업로드 되었습니다.',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.closePopup();
                this.$parent.init('');
            }
        },
        anamnesisInput(item) {
            item.anamnesisEtc = item.anamnesis.indexOf('기타') < 0 ? '' : item.anamnesisEtc;
        },
    },
};
</script>

<style>
.con-input-upload {
    width: 100%;
    margin: 0px;
}
.vs-con-tbody {
    width: 2000px;
    white-space: nowrap;
    overflow-x: scroll;
}
.vs-table--td {
    padding: 0px 2px !important;
}

.vs-table--td div {
    margin: 0px !important;
}
.vs-table--td div input {
    width: 120px !important;
}
</style>
